// Admin - Dashbaord.

import React from 'react';
import Config from '../../lib/Config';
import Header from '../../lib-ui/admin/Header';
import UIString from '../../assets/content/UIString';
import { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Input from '@mui/material/Input';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button } from '@mui/material';
import axios from 'axios';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavBar from '../../lib-ui/admin/NavBar';
import Alert from '@mui/material/Alert';
import Util from '../../lib/Util';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import Chip from '@mui/material/Chip';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Brightness1Icon from '@mui/icons-material/Brightness1';
import Block1Icon from '@mui/icons-material/Block';
import IOSSwitch from '../../lib-ui/common/IOSSwitch';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
//import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import Pagination from '@mui/material/Pagination';
import PagePanel from '../../lib-ui/common/PagePanel';
import SearchBar from '../../lib-ui/admin/SearchBar';
import { useSearchParams, useParams } from 'react-router-dom';
//기본 Line 차트
//https://react-chartjs-2.js.org/examples/line-chart
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import '../../assets/style/admin.css';
//import { pdfjs } from 'react-pdf';
//import { Document, Page } from 'react-pdf';
import Divider from '@mui/material/Divider';
import SectionNavButton from '../../lib-ui/common/SectionNavButton';



const lang = Util.get_lang();

export default () => {

    // const navigate = useNavigate();

    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [navTitle, setNavTitle] = useState('');
    const [flagContent, setFlagContent] = useState('');
    const [flagToast, setFlagToast] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastModeIcon, setToastModeIcon] = useState();
    const closeToast = () => { flagToast ? setFlagToast(false) : setFlagToast(true); }
    const showToast = (mode, msg) => {
        switch (mode) {
            case 'info': setToastModeIcon(<InfoIcon sx={{ fontSize: '32px', color: '#66ff66' }} />); break;
            case 'warning': setToastModeIcon(<WarningIcon sx={{ fontSize: '18px', color: '#6666ff' }} />); break;
            case 'error': setToastModeIcon(<WarningIcon sx={{ fontSize: '32px', color: '#a0a0a0' }} />); break;
        }

        setToastMsg(msg);
        setFlagToast(true);
    }

    const [detail, setDetail] = useState({
        request:{},
        corp:{},
        admin:{},
        corp_users:{}
    });


    const [lightbox, setLightbox] = useState(false);
    const [lightboxImages, setLightboxImages] = useState([]);




    useEffect(() => {

        setNavTitle([UIString[lang]['NAV_CORP_SIGNOUT_REQUEST_DETAIL'] + ' ' + params.id]);
        load_detail(params.id);

    }, []);







    function load_detail(id) {


        // Get data.
        let form = new FormData;
        Util.get(
            Util.api_url(lang, '/admin/corp/auth/signout/request/detail/' + id),
            (data) => {
                
                setDetail({
                    request:data.request,
                    corp:data.corp,
                    admin:data.admin
                });

            },
            (err) => {
                if (err.error_code == 'LOGIN_REQUIRED') {
                    alert(err.error);
                    document.location = Util.page_url(lang, '/');
                } else {
                    showToast(err.error);
                }
            }
        );
    }









    const complete = (t) => {

        const form = {
            name: 'status',
            value: 'DELETED'
        }

        Util.post(
            Util.api_url(lang, '/admin/corp/auth/signout/request/complete/' + t),
            form,
            (data) => {
                showToast('info', UIString[lang]['UPDATED']);
                load_detail(t);
            },
            (error) => {
                // document.location.href = '/admin/login';
                showToast(UIString[lang]['UPDATE_FAILED']);
            }
        );


    }





    function show_reg_image(img) {

        setLightboxImages([img]);
        setLightbox(true);

    }

    function show_reg_pdf(pdf_file) {

        const t = new Date().getTime();
        window.open(pdf_file);

    }


    // const nav_links = [{ label: 'Home', url: '/'+lang+'/admin/dashboard' }, { label: 'Dashboard', url: '/Dashboard' }];

    return (
        <>
            <Header code={'corp'} />
            <div style={{ width: '1000px', height: '100%', minHeight: '600px', paddingTop: '60px', textAlign: 'center', backgroundColor: '#ffffff', margin: '0px auto' }}>

                <Stack className='page_title' direction={'col'}>
                    <NavBar text={navTitle} key={navTitle} />
                    <span className='nav_right_button' style={{ whiteSpace: 'nowrap' }} onClick={() => { window.history.back() }}>{UIString[lang]['UPDATE']}</span>
                </Stack>


                <Paper elevation={0} sx={{ padding: '2px', textAlign: 'left', fontSize: '13px', marginBottom: '38px', display: `${flagContent}` }}>
<br />
                    <table style={{ width: '100%', bordeR: 'none', fontSize: '13px' }}>
                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>▪ Request</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{height:'18px'}} colSpan={2}><Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{ width: '148px' }}>ID</td>
                            <td className='detail_data_td'>{detail.request.id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp ID</td>
                            <td className='detail_data_td'>{detail.request.corp_id == null ? 'N/A' : detail.request.corp_id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp Name</td>
                            <td className='detail_data_td'>{detail.request.corp_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp Name (EN)</td>
                            <td className='detail_data_td'>{detail.request.corp_en_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Created IP</td>
                            <td className='detail_data_td'>{detail.request.created_ip}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Created</td>
                            <td className='detail_data_td'>{detail.request.created} / {detail.request.created_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Updated</td>
                            <td className='detail_data_td'>{detail.request.updated} / {detail.request.updated_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Status</td>
                            <td className='detail_data_td'>{detail.request.status}</td>
                        </tr>

                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>&nbsp;&nbsp;</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>▪ Corp</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{height:'18px'}} colSpan={2}><Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{ width: '148px' }}>ID</td>
                            <td className='detail_data_td'>{detail.corp.id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Link ID</td>
                            <td className='detail_data_td'>{detail.corp.link_id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>country</td>
                            <td className='detail_data_td'>{detail.corp.country}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Name</td>
                            <td className='detail_data_td'>{detail.corp.name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Name (EN)</td>
                            <td className='detail_data_td'>{detail.corp.en_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>CEO's Name</td>
                            <td className='detail_data_td'>{detail.corp.ceo_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>CEO's Name (EN)</td>
                            <td className='detail_data_td'>{detail.corp.ceo_en_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Address</td>
                            <td className='detail_data_td'>{detail.corp.address}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Address (EN)</td>
                            <td className='detail_data_td'>{detail.corp.en_address}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp Type</td>
                            <td className='detail_data_td'>{detail.corp.type == null ? 'N/A' : detail.corp.type}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp Type Desc</td>
                            <td className='detail_data_td'>{detail.corp.type_desc == null ? 'N/A' : detail.corp.type_desc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Reg Type</td>
                            <td className='detail_data_td'>{detail.corp.reg_type}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Reg Type Desc</td>
                            <td className='detail_data_td'>{detail.corp.reg_type_desc == null ? 'N/A' : detail.corp.reg_type_desc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Reg ID</td>
                            <td className='detail_data_td'>{detail.corp.reg_id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Reg Image</td>
                            <td className='detail_data_td'>{detail.corp.reg_image_file}</td>
                        </tr>
                        {detail.reg_image_file != null && String(detail.corp.reg_image_file).length > 4 && detail.corp.reg_image_file.substr(detail.corp.reg_image_file.length - 4, 4) == '.pdf' ? <tr>
                            <td className='detail_label_td'>&nbsp;&nbsp;</td>
                            <td className='detail_data_td'><img style={{ backgroundColor: '#ffffff', width: '80px', height: '100px', cursor: 'pointer', objectFit: 'contain', padding: '4px' }} onClick={() => { show_reg_pdf('/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_pdf/' + detail.corp.reg_image_file) }} src={`${'/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_image_pdf'}`} /></td>
                        </tr> : <tr>
                            <td className='detail_label_td'>&nbsp;&nbsp;</td>
                            <td className='detail_data_td'><img style={{ backgroundColor: '#ffffff', width: '80px', height: '100px', cursor: 'pointer', objectFit: 'cover' }} onClick={() => { show_reg_image('/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_image/' + detail.corp.reg_image_file) }} src={`${'/' + lang + '/api/v1/admin/corp/auth/signup/request/reg_image/' + detail.corp.reg_image_file}`} /></td>
                        </tr>}
                        <tr>
                            <td className='detail_label_td'>Logo Image</td>
                            <td className='detail_data_td'>{detail.corp.logo_image_file == null ? 'N/A' : detail.corp.logo_image_file}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>&nbsp;&nbsp;</td>
                            <td className='detail_data_td'><img style={{ backgroundColor: '#ffffff', width: '80px', height: '100px', cursor: 'pointer', objectFit: 'cover' }} onClick={() => { show_reg_image('/' + lang + '/api/v1/admin/corp/auth/signup/request/logo_image/' + detail.corp.logo_image_file) }} src={`${'/' + lang + '/api/v1/admin/corp/auth/signup/request/logo_image/' + detail.corp.logo_image_file}`} /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>DUNS number</td>
                            <td className='detail_data_td'>{detail.corp.duns_number == null ? 'N/A' : detail.corp.duns_number}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Tel</td>
                            <td className='detail_data_td'>{detail.corp.tel}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp User Count</td>
                            <td className='detail_data_td'>{detail.corp.user_count}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Created</td>
                            <td className='detail_data_td'>{detail.corp.created} / {detail.corp.created_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Updated</td>
                            <td className='detail_data_td'>{detail.corp.updated} / {detail.corp.updated_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Status</td>
                            <td className='detail_data_td'>{detail.corp.status}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>&nbsp;&nbsp;</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>▪ Admin</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{height:'18px'}} colSpan={2}><Divider sx={{ paddingLeft: '0px', '&::before': { width: 0 }, }} textAlign="left" /></td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Corp User ID</td>
                            <td className='detail_data_td'>{detail.admin.id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Link ID</td>
                            <td className='detail_data_td'>{detail.admin.link_id}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Email</td>
                            <td className='detail_data_td'>{detail.admin.email}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Name</td>
                            <td className='detail_data_td'>{detail.admin.name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Name (EN)</td>
                            <td className='detail_data_td'>{detail.admin.en_name}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Mobile Number</td>
                            <td className='detail_data_td'>{detail.admin.mobile_number == null ? 'N/A' : detail.admin.mobile_number}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Dept</td>
                            <td className='detail_data_td'>{detail.admin.dept}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Admin Position</td>
                            <td className='detail_data_td'>{detail.admin.position}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Created</td>
                            <td className='detail_data_td'>{detail.admin.created} / {detail.admin.created_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Updated</td>
                            <td className='detail_data_td'>{detail.admin.updated} / {detail.admin.updated_utc}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td'>Status</td>
                            <td className='detail_data_td'>{detail.admin.status}</td>
                        </tr>
                        <tr>
                            <td className='detail_label_td' style={{textAlign:'left',color:'#222222',height:'18px'}} colSpan={2}>&nbsp;&nbsp;</td>
                        </tr>
                       
                        <tr>
                            <td className='detail_label_td' style={{ height: '180px' }}>&nbsp;&nbsp;</td>
                            <td style={{ textAlign: 'left', padding: '0px' }} >
                                <table style={{ width: '100%', height: '180px', borderWidth: '0px', border: 'none', borderCollapse: 'collapse' }}>
                                    <tr>
                                        <td style={{ textAlign: 'left', paddingLeft: '8px' }}>

                                            &nbsp;&nbsp;
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                        {detail.request.status != 'COMPLETED' ? <Chip label="COMPLETE" color="#ffcc00" sx={{ width: '100px', fontSize: '11px', backgroundColor: '#c2ff00', color: '#222222', cursor: 'pointer' }} onClick={() => { complete(detail.request.id) }} /> : <></>}
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>


                    <br />

                </Paper>

                {flagContent == 'none' ? <Box sx={{ width: '100%', height: '600px', textAlign: 'center', fontSize: '13px' }}>
                    <WarningIcon style={{ fontSize: '80px', marginTop: '180px', marginBottom: '22px' }} /><br />
                    {UIString[lang]['NO_DATA']}
                </Box> : <></>}

                <div style={{ height: '600px' }}>&nbsp;&nbsp;</div>
                <Snackbar
                    sx={{}}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    open={flagToast}
                    onClose={closeToast}
                    autoHideDuration={1800}
                    key={'top' + 'center'}
                >
                    <SnackbarContent
                        sx={{
                            backgroundColor: '#fcfcfc',
                            color: '#222222',
                            minHeight: '60px',
                            fontSize: '13px',
                            display: "flex",
                            justifyContent: "space-between", // Space between text and icon
                            alignItems: "center",
                        }}

                        message={<Box display="flex" alignItems="center">
                            {toastModeIcon}&nbsp;&nbsp;
                            <span>&nbsp;&nbsp;{toastMsg}</span>
                        </Box>}
                        action={
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => console.log("Close clicked")}
                            >
                                <CloseIcon sx={{ cursor: 'pointer', fontSize: '18px', color: '#222222' }} onClick={() => { closeToast() }} />
                            </IconButton>}

                    />
                </Snackbar>



                {lightbox && (
                    <Lightbox

                        mainSrc={lightboxImages[0]}
                        //nextSrc={lightboxImages[(photoIndex + 1) % images.length]}
                        //prevSrc={lightboxImages[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => { setLightbox(false) }}
                    /*onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + images.length - 1) % images.length,
                        })
                    }
                    onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % images.length,
                        })
                    }*/
                    />
                )}

                <style>
                    {`
          .ReactModal__Overlay.ReactModal__Overlay--after-open {
            z-index: 1201 !important; /* Set above MUI AppBar */
          }
          .custom-lightbox .ril__outer {
            z-index: 1201 !important; /* Ensure lightbox container is above */
          }
        `}
                </style>




            </div>
        </>
    );

}